import { bool, string } from 'prop-types';
import React from 'react';
import { GoPencil, GoPlus } from 'react-icons/go';
import { MdDoNotDisturb } from 'react-icons/md';
import Moment from 'react-moment';

function TimestampInfo({
  timestamp,
  actionName,
  displayAttribute,
  author,
  fromNow,
}) {
  return (
    <div className="text-muted">
      {actionName === 'created' && <GoPlus />}{' '}
      {actionName === 'lastModified' && <GoPencil />}{' '}
      {actionName === 'closed' && <MdDoNotDisturb />}{' '}
      {fromNow ? (
        <Moment fromNow>{timestamp}</Moment>
      ) : (
        <Moment format="lll">{timestamp}</Moment>
      )}{' '}
      {author && <span className={`d-${displayAttribute}`}>by {author}</span>}
    </div>
  );
}

TimestampInfo.propTypes = {
  timestamp: string.isRequired,
  actionName: string.isRequired,
  author: string,
  displayAttribute: string,
  fromNow: bool,
};

TimestampInfo.defaultProps = {
  author: '',
  displayAttribute: 'block',
  fromNow: false,
};

export default TimestampInfo;
